import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
} from './actionTypes';

const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,
  forgetSuccess: null,
  insertData: false,
};

const forgetPassword = (state = initialState, action) => {
  switch (action.type) {
    case FORGET_PASSWORD:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
        insertData: true,
        forgetSuccess: null,
      };
      break;
    case FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        forgetSuccessMsg: action.payload,
        insertData: false,
        forgetSuccess: true,
      };
      break;
    case FORGET_PASSWORD_ERROR:
      state = { ...state, forgetError: action.payload, forgetSuccess: false, insertData: false, };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default forgetPassword;
